/**
 * Umschalter für das Erscheinungsbild — hell, dunkel oder wie das Gerät.
 *
 * Sitzt in der Kopfzeile des Leitstands. Bewusst drei Stellungen statt eines
 * Kippschalters: „wie das Gerät" ist für viele die richtige Antwort, und wer
 * sich festlegen will, soll das ausdrücklich tun können — nicht durch Raten,
 * welche Stellung gerade wirkt.
 */

import { useEffect, useState } from 'react';
import { Farbschema, gespeichertesSchema, merkeSchema } from '../../lib/farbschema';

const STELLUNGEN: Array<{ wert: Farbschema; text: string; titel: string }> = [
  { wert: 'hell', text: 'Hell', titel: 'Immer helles Bild' },
  { wert: 'dunkel', text: 'Dunkel', titel: 'Immer dunkles Bild' },
  { wert: 'system', text: 'Gerät', titel: 'So, wie das Gerät eingestellt ist' },
];

export function SchemaSchalter() {
  const [schema, setSchema] = useState<Farbschema>('system');

  useEffect(() => setSchema(gespeichertesSchema()), []);

  function waehle(wert: Farbschema) {
    setSchema(wert);
    merkeSchema(wert);
  }

  return (
    <div
      className="flex items-center gap-px rounded-[5px] border border-linie-2 bg-flaeche p-px"
      role="group"
      aria-label="Erscheinungsbild"
    >
      {STELLUNGEN.map((s) => (
        <button
          key={s.wert}
          onClick={() => waehle(s.wert)}
          title={s.titel}
          aria-pressed={schema === s.wert}
          className={`rounded-[4px] px-[7px] py-[3px] font-zahl text-[10px] uppercase tracking-[0.08em] transition-colors ${
            schema === s.wert ? 'bg-akzent-tief text-akzent' : 'text-tinte-3 hover:text-tinte-2'
          }`}
        >
          {s.text}
        </button>
      ))}
    </div>
  );
}
